/**
 * Labstep
 *
 * @module ProtocolTimer/Form/Edit
 * @desc Protocol Timer Edit Form
 */

import { protocolTimerFormFields } from 'labstep-web/components/ProtocolTimer/Form/fields';
import { preSubmit } from 'labstep-web/components/ProtocolTimer/Form/utils';
import { EditFormUpdateContainer as EditForm } from 'labstep-web/core/Form/Edit';
import type React from 'react';
import type { IProtocolTimerFormEditProps } from './types';

export const ProtocolTimerFormEdit: React.FC<
  IProtocolTimerFormEditProps
> = ({ protocolTimer, options }) => (
  <div>
    <EditForm
      autoFocus
      entity={protocolTimer}
      entityName={protocolTimer.entityName}
      fields={protocolTimerFormFields}
      options={options}
      preSubmit={preSubmit}
    />
  </div>
);
